export type SiteCreatedTriggerInput = {
  salesFolderId?: unknown;
  siteId?: unknown;
};

/**
 * User-initiated site INSERT only. Region, forward-only, and AU/US no-op are engine concerns.
 */
export function shouldEvaluateSiteCreated(input: SiteCreatedTriggerInput): boolean {
  return hasId(input.salesFolderId) && hasId(input.siteId);
}

function hasId(id: unknown): boolean {
  return id != null && id !== '';
}
